import SettingsMobileListControls from "@/components/SettingsMobileListControls/SettingsMobileListControls.vue";

export default {
    name: "SettingsPropertyTab",

    components: {
        SettingsMobileListControls
    },

    props: {
        tariff_rows: {
            type: Array,
            default: () => []
        },
        get_assignment_date_range: {
            type: Function,
            required: true
        }
    },

    emits: [
        "add-tariff",
        "view-rates",
        "edit-assignment"
    ],

    data() {
        return ({
            mobile_page: 1,
            mobile_page_size: 5,
            mobile_search: ""
        });
    },

    computed: {
        filtered_mobile_tariff_rows() {
            return this.filter_mobile_rows(this.tariff_rows, [
                "property_name",
                "tariff_name",
                "tariff_book_name",
                "tariff_code",
                "tariff_category",
                "municipality_name"
            ]);
        },

        mobile_page_count() {
            return Math.max(1, Math.ceil(this.filtered_mobile_tariff_rows.length / this.mobile_page_size));
        },

        paginated_mobile_tariff_rows() {
            const start_index = (this.mobile_page - 1) * this.mobile_page_size;
            return this.filtered_mobile_tariff_rows.slice(start_index, start_index + this.mobile_page_size);
        }
    },

    watch: {
        tariff_rows() {
            this.mobile_page = 1;
        },

        mobile_search() {
            this.mobile_page = 1;
        }
    },

    methods: {
        set_mobile_page(page) {
            this.mobile_page = Math.min(Math.max(Number(page), 1), this.mobile_page_count);
        },

        filter_mobile_rows(rows, fields) {
            const search = this.mobile_search.trim().toLowerCase();

            if (!search) return rows;

            return rows.filter((row) => {
                return fields.some((field) => String(row?.[String(field)] || "").toLowerCase().includes(search));
            });
        }
    }
};
